<template>
  <div @click="$emit('click')" class="secured-media-wrapper">
    <div v-if="isLoading" class="d-flex justify-center align-center secured-media-loader">
      <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>

    <v-img v-else-if="mediaType === 'image' && blobUrl" :src="blobUrl" class="secured-media-content"></v-img>

    <video v-else-if="mediaType === 'video' && blobUrl" :src="blobUrl" controls class="secured-media-content"></video>

    <audio v-else-if="mediaType === 'audio' && blobUrl" :src="blobUrl" controls></audio>

    <div v-else-if="!isLoading" class="secured-media-error">
      <v-icon color="red" class="mr-2">mdi-alert-circle</v-icon>
      Ladefehler
    </div>
  </div>
</template>

<script>
// Wichtig: Importiere deine zentrale axios-Instanz aus chatApi.js
import api from "@/api"

// Optional: Ein kleiner In-Memory-Cache, damit wir nicht 100x dasselbe Bild laden
const mediaCache = new Map()

export default {
  name: "SecuredMedia",
  props: {
    filename: { type: String, required: true },
    mediaType: { type: String, required: true }, // 'image', 'video', 'audio'
  },
  data() {
    return {
      isLoading: false,
      blobUrl: null,
    }
  },
  async created() {
    console.log("hallo")
    if (!this.filename) return

    // 1. Aus Cache laden (schnell)
    const cachedBlob = mediaCache.get(this.filename)
    if (cachedBlob) {
      this.blobUrl = URL.createObjectURL(cachedBlob)
      return
    }

    // 2. Vom Server laden (langsam)
    this.isLoading = true
    try {
      console.log("lade gesicherte medien")
      // Wir brauchen eine neue Methode in chatApi.js
      const response = await api.fetchSecuredMedia(this.filename)
      console.log(response)
      const blob = new Blob([response.data], { type: response.headers["content-type"] })

      mediaCache.set(this.filename, blob) // In Cache speichern
      this.blobUrl = URL.createObjectURL(blob)
    } catch (err) {
      console.error("Fehler beim Laden der gesicherten Medien:", err)
    } finally {
      this.isLoading = false
    }
  },
  beforeDestroy() {
    // Wichtig, um Memory-Leaks zu verhindern
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl)
    }
  },
}
</script>

<style scoped>
.secured-media-wrapper {
  cursor: pointer;
  position: relative;
}
.secured-media-loader {
  background-color: #272727;
  border-radius: 8px;
}
.secured-media-content {
  max-height: 400px; /* (Maximale Höhe in der VORSCHAU behalten wir) */
  border-radius: 8px;
  display: block;
}
.secured-media-error {
  height: 100px;
  color: red;
  display: flex;
  align-items: center;
}
</style>
